import { IconButton } from '@components/core/icon-button.component';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@components/ui/tooltip';
import { cn } from '@lib/utils';
import { CheckIcon, EditIcon, XIcon } from 'lucide-react';
import React from 'react';

type EditSectionControlsProps = {
  cancelAriaLabel: string;
  className?: string;
  editAriaLabel: string;
  editDisabledTooltip?: string;
  isCancelDisabled?: boolean;
  isEditDisabled?: boolean;
  isEditing: boolean;
  isSaveDisabled?: boolean;
  onCancel: () => void;
  onEdit: () => void;
  onSave: () => void;
  saveAriaLabel: string;
};

export const EditSectionControls: React.FC<EditSectionControlsProps> = (props) => {
  const {
    cancelAriaLabel,
    className,
    editAriaLabel,
    editDisabledTooltip,
    isCancelDisabled = false,
    isEditDisabled = false,
    isEditing,
    isSaveDisabled = false,
    onCancel,
    onEdit,
    onSave,
    saveAriaLabel,
  } = props;

  if (isEditing) {
    return (
      <div className={cn('absolute top-2 right-2 flex gap-1', className)}>
        <IconButton
          ariaLabel={cancelAriaLabel}
          disabled={isCancelDisabled}
          icon={<XIcon size={16} />}
          onClick={onCancel}
          size="md"
          variant="secondary"
        />
        <IconButton
          ariaLabel={saveAriaLabel}
          disabled={isSaveDisabled}
          icon={<CheckIcon size={16} />}
          onClick={onSave}
          size="md"
          variant="primary"
        />
      </div>
    );
  }

  const editButton = (
    <IconButton
      ariaLabel={editAriaLabel}
      className="hidden group-hover:flex"
      disabled={isEditDisabled}
      icon={<EditIcon size={16} />}
      onClick={onEdit}
      size="md"
      variant="secondary"
    />
  );

  return (
    <div className={cn('absolute top-2 right-2', className)}>
      {editDisabledTooltip && isEditDisabled ? (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger asChild>{editButton}</TooltipTrigger>
            <TooltipContent className="text-xs">{editDisabledTooltip}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        editButton
      )}
    </div>
  );
};
